import { axios, callFes } from '..';

export const largeFileUpload = async (
  file: MediaStorageService.Schemas.FilesRequestPost
): Promise<MediaStorageService.Schemas.FilesResponse> => {
  return callFes.post('large-file-upload', file, true);
};

export const largeFileDownload = async (url: string): Promise<any> => {
  return axios.get(url, { responseType: 'blob' });
};
